app.mediator.registerModule(MODULE_NAME__UPLOAD_IMAGES_CAPTIONS, function (app) {

    var dataStore = app.data;
    var helpers = app.helpers.funcs;
    var dummyImageUrl = helpers.url('Resources/app/assets/img/ui/image-file-icon.png');
    var uploadTargetUrlAux = helpers.url('/umbraco/api/DocumentApi/UploadEntryImage');
    var blockScroll = false; // Causes scrolling to be disabled on touch devices
    var debugBlockScroll = false;
    var defaultImageTitles = ['Main image', 'Image 2', 'Image 3', 'Image 4', 'Image 5'];
    var dropAreasEnabledClass = 'drop-areas-enabled';

    return {

        // The jQuery DOM element (i.e. the create entry form)
        $modElem: null,

        // The handle for the drag and drop plugin instance
        sortableHandle: null,

        imageTitles: [],

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },

        init: function () {

            // This stops firefox from opening lots of new tabs when you try to rapidly change the order of the cards.
            // See: ITDCI-6480
            document.body.ondrop = function (e) {
                e.preventDefault();
                e.stopPropagation();
            };

            // Init
            var scope = this;

            // Prepare data
            this.$modElem = $('.mod-upload-images-captions');

            // Don't bother to add the event listeners if the form DOM element does not exist
            // i.e. We are on another page. This will save memory.
            if (!this.$modElem.length) return;

            // Init drag and drop
            // Limiting the elements that can be used for a drag and drop handle means that users
            // can still use the mouse to highlight text in the textarea within when visiting the site with Firefox or IE.
            // However, for moving the image cards, they will be restricted to using the handle icon only.
            // See: ITDCI-6480
            var handleSelector = app.helpers.funcs.isFirefox() || app.helpers.funcs.isIe() ? '.button-wrap.handle' : '.handle';
            var sortableWrapElem = this.$modElem.find(' >.row').get(0);
            var sortableOptions = {
                handle: handleSelector,
                animation: 250,
                filter: '.card-clear',
                onStart: function (e) {
                    scope.disableDropArea();
                    $.scrollLock(true);
                },
                onEnd: function (e) {
                    $.scrollLock(false);
                    scope.adjustOrderInputsAndTitles(false);
                    setTimeout(function () {
                        $('.image-caption-card-col').removeClass('lifted');
                    }, 500);
                    scope.enableDropArea();
                }
            };
            if ($('body').hasClass('isMobile')) {
                sortableOptions.delay = 500;
            }
            this.sortableHandle = new Sortable(sortableWrapElem, sortableOptions);

            // Add event listeners
            this.addEventListeners();
            this.addMediatorListeners();

            this.$modElem.find('label.caption-label .sr-only, .action-delete .sr-only, .file-label.sr-only').each(function (k, label) {
                var $label = $(label);
                var textNode = $label.contents().first();
                app.helpers.funcs.replaceCharacterPlaceholderWithElement(textNode);
            });

            // Adjust dropzone classes to account for files that may already exist for previously saved drafts.
            scope.adjustDropzoneClasses();
            scope.adjustOrderInputsAndTitles(true);

        },

        //==========================================================xdiv2====
        // DOM event handlers
        //===================================================================

        addEventListeners: function () {

            var scope = this;

            this.$modElem.find('.image-box-image, .no-image-box').on('drag dragstart dragend dragenter dragleave drop', function (e) {
                $(this).closest('.image-caption-card').removeClass('dragged-over');
            });
            this.$modElem.find('.image-box-image, .no-image-box').on('dragover', function (e) {
                $(this).closest('.image-caption-card').addClass('dragged-over');
            });
            this.$modElem.find('.image-wrap').on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
                e.preventDefault();
                e.stopPropagation();
            });
            this.$modElem.find('input[type=file]').change(function (e) {
                var $inputElem = $(this);
                scope.fileInputOnChange($inputElem, e);
            });
            this.$modElem.find('.image-box, .no-image-box').click(function () {
                $(this).closest('.image-caption-card').find('input[type=file]').trigger('click');
            });
            this.$modElem.find('input[type=file]').focus(function (e) {
                $(this).closest('.image-wrap').addClass('focus');
            });
            this.$modElem.find('input[type=file]').blur(function (e) {
                $(this).closest('.image-wrap').removeClass('focus');
            });
            this.$modElem.find('button.handle').on('click', function (e) {
                // Prevent the form form submitting
                e.preventDefault();
            });
            // Replace jQuery Mobile-only `taphold`/`vmouseup` handlers with native
            // long-press and release events to keep mobile drag affordance.
            this.$modElem.find(' >.row .handle').each(function () {
                var holdTimer = null;
                var $handle = $(this);

                var clearLiftedState = function () {
                    if (holdTimer) {
                        clearTimeout(holdTimer);
                        holdTimer = null;
                    }
                    if ($('body').hasClass('isMobile')) {
                        $handle.closest('.image-caption-card-col').removeClass('lifted');
                    }
                };

                $handle.on('touchstart mousedown', function () {
                    if (!$('body').hasClass('isMobile')) return;
                    holdTimer = setTimeout(function () {
                        $handle.closest('.image-caption-card-col').addClass('lifted');
                    }, 700);
                });

                $handle.on('touchend touchcancel mouseup mouseleave', clearLiftedState);
            });
            this.$modElem.find('.action-delete').on('click', function (e) {
                e.preventDefault();
                var $cardCol = $(this).closest('.image-caption-card-col');
                scope.clearImagePreviewBox($cardCol);
            });
            this.$modElem.find('.image-order-input').focus(function () {
                $(this).parent().addClass('focused');
            });
            this.$modElem.find('.image-order-input').blur(function () {
                $(this).parent().removeClass('focused');
            });

            this.enableDropArea();
            this.$modElem.find('.image-wrap').on('drop', function (e) {
                var $inputElem = $(this).closest('.image-caption-card').find('input[type=file]');
                scope.dropAreaOnDrop($inputElem, e);
            });
        },

        //==========================================================xdiv2====
        // Mediator event handlers
        //===================================================================

        addMediatorListeners: function () {
            var scope = this;
            app.mediator.addListener(EVENT_NAME__UPLOAD_IMAGES_CAPTIONS__FILE_REMOVED, function () {
                app.ui.uiPlugins.toast.fireScreenReaderOnly(serverData.generalLanguageStrings.fileRemovedMessage);
            });
            app.mediator.addListener(EVENT_NAME__UPLOAD_IMAGES_CAPTIONS__FILE_UPLOAD_COMPLETE, function (data) {
                if (data.success) {
                    app.ui.uiPlugins.toast.fireScreenReaderOnly(serverData.generalLanguageStrings.fileUploadedSuccessfullyMessage);
                } else {
                    app.ui.uiPlugins.toast.fireScreenReaderOnly(serverData.generalLanguageStrings.fileUploadFailedMessage);
                }
            });
            app.mediator.addListener(EVENT_NAME__ENTER_FORM__IMAGE_DOESNT_EXIST,
                function (data) {
                    var $cardCol = $("input[value=" + data.documentId + "]")
                        .closest(".image-caption-card-col");
                    scope.clearImagePreviewBox($cardCol);
                });
        },

        //==========================================================xdiv2====
        // Module
        //===================================================================

        canShowRealThumbs: function() {
            return app.helpers.funcs.fileReaderSupported();
        },

        enableDropArea: function () {
            $('body').addClass(dropAreasEnabledClass);
        },

        disableDropArea: function () {
            $('body').removeClass(dropAreasEnabledClass);
        },

        adjustDropzoneClasses: function () {
            var scope = this;
            this.$modElem.find('.image-caption-card').each(function (k, imageCaptionCard) {
                var $imageCaptionCard = $(imageCaptionCard);
                var $documentIdInput = $imageCaptionCard.find('input.document-id-input');
                var hasImage = !!$documentIdInput.val();
                var theClass = hasImage ? 'has-image' : '';
                scope.adjustDropzoneClass($imageCaptionCard, theClass);
                scope.setCaptionFieldsEnabled($imageCaptionCard, hasImage);
            });
        },

        adjustDropzoneClass: function($imageCaptionCard, theClass) {
            $imageCaptionCard.removeClass('has-image')
                .addClass(theClass);
        },

        setCaptionFieldsEnabled: function ($imageCaptionCard, enabled) {
            $imageCaptionCard.find('textarea').prop('disabled', !enabled);
        },

        addImageTitle: function (string) {
            this.imageTitles.push(string);
        },
        getImageTitles: function () {
            if (this.imageTitles.length === 0) return defaultImageTitles;
            return this.imageTitles;
        },

        // Replace all tags for each cluster of inputs that pertain to an uploaded image and caption.
        // By replacing validation names, ids, error targets and so on, we ensure that the first item
        // continues to be validated against first item rules, despite the reordering of elements.
        adjustOrderInputsAndTitles: function (callToThisFunctionWasOnInit) {
            var scope = this;
            var imageTitles = this.getImageTitles();

            var replaceAllData = function ($elem, name, val) {
                $elem.data(name, val);
                $elem.attr('data-' + name, val);
            }
            
            this.$modElem.find('.image-caption-card').each(function (k, imageCaptionCard) {

                var idx = k + 1;

                // Get the main elements for each "card" div
                var $imageCaptionCard = $(imageCaptionCard);
                var $titleElem = $imageCaptionCard.find('.card-title');
                var $orderInput = $imageCaptionCard.find('input.image-order-input');
                var $fileElem = $imageCaptionCard.find('input[type=file]');
                var $fileDocIdInputElem = $imageCaptionCard.find('input.document-id-input');

                // Get the double elements for each "card" div
                // We have two each of the below - one for english language, and one
                // for alternative language.
                var $captionElems = $imageCaptionCard.find('textarea');
                var $messageTargetSpans = $imageCaptionCard.find('.messages-wrap .error-target');

                // The buttons and screen reader labels
                var $deleteBtn = $imageCaptionCard.find('.action-delete');
                var $deleteBtnInner = $imageCaptionCard.find('.action-delete .value');
                var $captionLabelElem = $imageCaptionCard.find('label.caption-label');
                var $captionLabelElemInner = $imageCaptionCard.find('label.caption-label .value');
                var $fileLabelElem = $imageCaptionCard.find('label.file-label');
                var $fileLabelElemInner = $imageCaptionCard.find('label.file-label .value');

                // Before we change anything, update the cards "last position" store, so we
                // know where it was located before the shuffle. This is useful to know, as it
                // helps us rebase the cached file input values at the end.
                // (Which is done in modules that have access to a validator instance, such as enterForm.js).
                var currentPosition = $fileElem.data('validation-name').replace(/[^0-9]/g, '');
                $imageCaptionCard.data('last-position', currentPosition);

                // Replace main / aux card class to indicate if this card is for the "main image"
                // (i.e. the first of 5), or an auxillary image (i.e. image 2-5 inclusive).
                var newOrderClass = k == 0 ? 'image-caption-card-main-image' : 'image-caption-card-aux-image';
                $imageCaptionCard.removeClass('image-caption-card-main-image').removeClass('image-caption-card-aux-image').addClass(newOrderClass);

                // Replace the title to read "Main image" / "Image 2" etc, depending on the cards new position.
                $titleElem.text(imageTitles[k]);

                // Update the hidden "order" form input
                $orderInput.val(idx);

                // Update validation name, error target, id on file input
                replaceAllData($fileElem, 'validation-name', 'imageFile-' + idx);
                replaceAllData($fileElem, 'error-target', '.file-error-target-' + idx);
                $fileElem.attr('id', 'imageFileInput' + idx);

                // Update hidden "document id" form input
                replaceAllData($fileDocIdInputElem, 'validation-name', 'imageDocumentId-' + idx);
                replaceAllData($fileDocIdInputElem, 'error-target', '.file-error-target-' + idx);
                $fileDocIdInputElem.attr('id', 'imageDocumentId-' + idx);

                // Update validation name, error target, id on textareas (eng and aux languages)
                $captionElems.each(function (captionElementIndex, captionElement) {
                    var $captionElem = $(captionElement);
                    replaceAllData($captionElem, 'validation-name', $captionElem.data('validation-name').replace(/[0-9]/g, idx));
                    replaceAllData($captionElem, 'error-target', $captionElem.data('error-target').replace(/[0-9]/g, idx));
                    $captionElem.attr('id', $captionElem.attr('id').replace(/[0-9]/g, idx));
                });

                // Update error target classnames
                $messageTargetSpans.each(function (captionElementIndex, messageTargetElement) {
                    $(messageTargetElement).attr('class', $(messageTargetElement).attr('class').replace(/[0-9]/g, idx));
                });

                // Replace the screen reader text for the delete button, replace id.
                $deleteBtn.attr('id', $deleteBtn.attr('id').replace(/[0-9]/g, idx));
                $deleteBtnInner.text(imageTitles[k]);

                // Replace the textarea label for screen readers, replace for.
                $captionLabelElem.attr('for', 'captionInput-' + idx);
                $captionLabelElemInner.text(imageTitles[k]);

                // Replace file input label for screen readers, replace for.
                $fileLabelElem.attr('for', 'imageFileInput' + idx);
                $fileLabelElemInner.text(imageTitles[k]);
            });

            // Notify other modules, via the mediator that the rejiggering event has completed.
            // Note that this rejiggering operation will have broken any links between each file inputs 
            // data-validation-name key and the cached input values that may be stored in the validation
            // library. If a form mediator module wraps the uploadImagesCaptions module, it must handle this
            // when it "hears" the firing of a "EVENT_NAME__UPLOAD_IMAGES_CAPTIONS__CARDS_REORDERED" event,
            // which is emitted here, directly below this line...
            app.mediator.notify(EVENT_NAME__UPLOAD_IMAGES_CAPTIONS__CARDS_REORDERED, {
                eventWasBroadcastOnInitOfUploadImagesCaptionsModule: callToThisFunctionWasOnInit
            });
        },

        fileInputOnChange: function ($fileInputElem, e) {
            var files = e.target.files;
            var eType = 'standard';
            this.handleFilesEvent($fileInputElem, e, eType, files);
        },

        dropAreaOnDrop: function ($fileInputElem, e) {
            if (!$('body').hasClass(dropAreasEnabledClass)) return;
            var files = e.originalEvent.dataTransfer.files;
            var eType = 'drop';
            this.handleFilesEvent($fileInputElem, e, eType, files);
        },

        handleFilesEvent: function ($fileInputElem, e, eType, files) {
            var $docIdInputElem = $fileInputElem.parent().find('.document-id-input');
            var $imageElement = $fileInputElem.parent().find('.image-box img');
            $fileInputElem.data('uploadImagesCaptionsFiles', files);
            this.uploadFileWithAjax(files[0], function (guid, url) {
                $docIdInputElem.val(guid);
            });
            $fileInputElem.trigger('uploadImagesCaptions.filesSet', {
                files: files,
                evtType: eType,
                evt: e
            });
            var file = files[0];
            this.updateImagePreview($fileInputElem, file);
        },

        uploadFileWithAjax: function (file, callback) {
            var formData = new FormData();
            formData.append('file', file);
            app.mediator.notify(EVENT_NAME__UPLOAD_IMAGES_CAPTIONS__FILE_UPLOAD_STARTED);
            $.ajax({
                type: "POST",
                url: uploadTargetUrlAux,
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                dataType: "json",
                success: function (response) {
                    var guid = null;
                    var url = null;

                    if (response.success && response.result) {
                        guid = response.result.id;
                        url = response.result.url;
                    }

                    if (typeof callback == 'function') {
                        callback.call(null, guid, url);
                    }
                    app.mediator.notify(EVENT_NAME__UPLOAD_IMAGES_CAPTIONS__FILE_UPLOAD_COMPLETE, {
                        success: true
                    });
                },
                error: function (response, status, err) {
                    console.log(arguments);
                    app.mediator.notify(EVENT_NAME__UPLOAD_IMAGES_CAPTIONS__FILE_UPLOAD_COMPLETE, {
                        success: false
                    });
                }
            });
        },

        updateImagePreview: function ($fileInputElem, file) {
            var scope = this;
            var $cardElem = $fileInputElem.closest('.image-caption-card');
            var $previewElem = $cardElem.find('.image-box-image');
            if (file) {
                var $imageCaptionCard = $fileInputElem.closest('.image-caption-card');
                scope.setCaptionFieldsEnabled($imageCaptionCard, true);
                if (file.type.match('image.*') && scope.canShowRealThumbs()) {
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        $previewElem.css({ backgroundImage: 'url(' + e.target.result + ')' });
                        scope.adjustDropzoneClass($cardElem, 'has-image');
                        $imageCaptionCard.find('.action-delete').attr('aria-hidden', 'false').attr('tabindex', 0);
                    };
                    reader.readAsDataURL(file);
                } else {
                    $previewElem.css({ backgroundImage: 'url(' + dummyImageUrl + ')' });
                    scope.adjustDropzoneClass($cardElem, 'has-image');
                    $imageCaptionCard.find('.action-delete').attr('aria-hidden', 'true').attr('tabindex', -1);
                }
            }
        },

        clearImagePreviewBox: function ($cardCol) {
            $cardCol.find('input.id-input').val('');
            $cardCol.find('input.document-id-input').val('');
            $cardCol.find('input.file-input').val('');

            $cardCol.find('.image-caption-card').removeClass('has-image');
            $cardCol.find('.action-delete').attr('aria-hidden', 'true').attr('tabindex', -1);

            // We then clear the textarea value. We trigger keyup after this,
            // to ensure that the characters remaining counter resets, and the "filled"
            // class gets removed, so that the "Caption" label element moves back down to occupy
            // the edit area.
            $cardCol.find('textarea').val('').trigger('keyup');
            this.setCaptionFieldsEnabled($cardCol.find('.image-caption-card'), false);
            app.mediator.notify(EVENT_NAME__UPLOAD_IMAGES_CAPTIONS__FILE_REMOVED,
            {
                $cardCol: $cardCol
            });
        }
    };
});
